export default "/_next/static/media/Peer-to-peer-Fundraising-crowdfunding-platform-1024x970.b7877c56ebacfda76c96fa3b0ddc4664.png";